import React from 'react';
import { motion } from 'framer-motion';
import { Magnet, Calendar, CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Solution() {
  const days = [{
    day: 'Día 1',
    title: 'El Clon del Socio Ideal',
    desc: "Aprende a identificar quién es exactamente la persona que te dirá 'SÍ' sin objeciones."
  }, {
    day: 'Día 2-3',
    title: 'La Bio y el Feed Blindado',
    desc: 'Configuramos tu perfil para que sea una vitrina profesional de 24/7.'
  }, {
    day: 'Día 4-5',
    title: 'Ingeniería de Reels e Historias',
    desc: 'Ganchos específicos para Networkers que generan comentarios, no solo vistas.'
  }, {
    day: 'Día 6-7',
    title: 'El Cierre Magnético',
    desc: 'Guiones exactos para pasar del comentario de Instagram a la presentación de negocio sin presión.'
  }];
  return;
}